import styles from "./SiteHeader.module.css";

function SiteHeader() {
    return (
        <>
            <div className={styles.wrapper}>We love Mallards</div>
        </>
    );
}

export default SiteHeader;
